// store/modalSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  twoFactorSetupOpen: false,
  cookieConsentOpen: false,
  cookieConsentMode: "required",
  passwordPolicyOpen: false,
  settingsPasswordOpen: false,
  settingsEmailOpen: false,
};

const modalSlice = createSlice({
  name: "modals",
  initialState,
  reducers: {
    // --- Two Factor ---
    openTwoFactorSetup(state) {
      state.twoFactorSetupOpen = true;
    },
    closeTwoFactorSetup(state) {
      state.twoFactorSetupOpen = false;
    },

    // --- Cookie Consent ---
    openCookieConsent(state, action) {
      state.cookieConsentOpen = true;
      state.cookieConsentMode = action.payload?.mode || "required";
    },
    closeCookieConsent(state) {
      state.cookieConsentOpen = false;
      state.cookieConsentMode = "required";
    },

    // --- Password Policy ---
    openPasswordPolicy(state) {
      state.passwordPolicyOpen = true;
    },
    closePasswordPolicy(state) {
      state.passwordPolicyOpen = false;
    },

    // --- Settings Password ---
    openSettingsPassword(state) {
      state.settingsPasswordOpen = true;
    },
    closeSettingsPassword(state) {
      state.settingsPasswordOpen = false;
    },

    // --- Settings Email ---
    openSettingsEmail(state) {
      state.settingsEmailOpen = true;
    },
    closeSettingsEmail(state) {
      state.settingsEmailOpen = false;
    },
  },
});

export const {
  openTwoFactorSetup,
  closeTwoFactorSetup,
  openCookieConsent,
  closeCookieConsent,
  openPasswordPolicy,
  closePasswordPolicy,
  openSettingsPassword,
  closeSettingsPassword,
  openSettingsEmail,
  closeSettingsEmail,
} = modalSlice.actions;

export default modalSlice.reducer;
